import axios from 'axios'

export default {
  getInventory: async function (inventoryType, productId) {
    const url = '/Inventory/' + inventoryType + '/' + productId
    const response = await axios.get(url, { crossdomain: true })
    return response.data
  },
}
